import Axios from 'axios'
import { Server } from '../components/globals'

const Client = Axios.create({ baseURL: Server })

Client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')

    if (token) {
      config.headers['authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

export default Client
